import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5022f27f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"min-width":"600px"},
  class: "flex col"
}
const _hoisted_2 = {
  key: 0,
  class: "text-red"
}
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = { class: "flex grow justify-between" }
const _hoisted_5 = { class: "flex align-center" }
const _hoisted_6 = { class: "text-muted" }
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = { class: "flex grow align-center justify-between" }
const _hoisted_9 = { class: "main-layout" }
const _hoisted_10 = { class: "container g12 flex col" }
const _hoisted_11 = { class: "flex grow align-center justify-between" }
const _hoisted_12 = { class: "flex align-center" }
const _hoisted_13 = { class: "flex align-center" }
const _hoisted_14 = {
  class: "bold",
  scope: "col"
}
const _hoisted_15 = {
  class: "text-muted",
  scope: "col"
}
const _hoisted_16 = {
  class: "bold",
  scope: "col"
}
const _hoisted_17 = { scope: "row" }
const _hoisted_18 = { class: "flex col g0" }
const _hoisted_19 = { class: "text-muted f12" }
const _hoisted_20 = { class: "flex" }
const _hoisted_21 = { class: "flex g0" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "f16" }, "+", -1))
const _hoisted_23 = { class: "text-muted" }
const _hoisted_24 = {
  style: {"text-align":"center"},
  scope: "row"
}
const _hoisted_25 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VDatePicker = _resolveComponent("VDatePicker")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_ReadonlyField = _resolveComponent("ReadonlyField")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Button = _resolveComponent("Button")!
  const _component_SeModal = _resolveComponent("SeModal")!
  const _component_NavHeader = _resolveComponent("NavHeader")!
  const _component_SeCalendarRanged = _resolveComponent("SeCalendarRanged")!
  const _component_SeButton = _resolveComponent("SeButton")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SeModal, {
      ref: "editModal",
      title: "Edit"
    }, {
      default: _withCtx(() => [
        (_ctx.selectedEmployee != null && _ctx.selectedEntry != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_ctx.errorMsg)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.errorMsg), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_Card, null, {
                header: _withCtx(() => [
                  _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.selectedEntry.is_in ? "Entrance" : "Exit"), 1)
                ]),
                body: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.Lang.getI18N("date")) + " :", 1),
                      _createVNode(_component_VDatePicker, {
                        is24hr: "",
                        "hide-time-header": "",
                        modelValue: _ctx.selectedEntry.timestamp_modified,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedEntry.timestamp_modified) = $event)),
                        mode: "time"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createVNode(_component_ReadonlyField, {
                      locked: true,
                      class: "flex align-center"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.Lang.getI18N("original-entry")), 1),
                        (_ctx.selectedEntry.timestamp)
                          ? (_openBlock(), _createBlock(_component_VDatePicker, {
                              key: 0,
                              is24hr: "",
                              "hide-time-header": "",
                              modelValue: _ctx.selectedEntry.timestamp,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedEntry.timestamp) = $event)),
                              mode: "time"
                            }, null, 8, ["modelValue"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_Badge, { color: "#e08f48" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("no-value")), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Button, { onClick: _ctx.deletePunchCard }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("delete")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, { onClick: _ctx.closeEditModal }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("close")), 1)
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_NavHeader, {
        backButton: "true",
        title: _ctx.Lang.getI18N('punch-cards')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_SeCalendarRanged, { ref: "datePicker" }, null, 512),
            _createVNode(_component_SeButton, {
              icon: "ico/search_white.svg",
              onPress: _ctx.search
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("search")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_SeButton, {
              ref: "exportBtn",
              onPress: _ctx.exportCSV,
              icon: "ico/export.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("export")) + " CSV", 1)
              ]),
              _: 1
            }, 8, ["onPress"]),
            _createVNode(_component_SeButton, {
              onPress: _ctx.exportPDF,
              icon: "ico/export.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("export")) + " PDF", 1)
              ]),
              _: 1
            }, 8, ["onPress"]),
            _createVNode(_component_SeButton, {
              ref: "saveBtn",
              onPress: _ctx.save,
              icon: "ico/save.svg"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.Lang.getI18N("save")), 1)
              ]),
              _: 1
            }, 8, ["onPress"])
          ])
        ]),
        _createVNode(_component_Panel, {
          class: "p12 grow flex",
          style: {"max-width":"100%","border-radius":"12px","overflow":"scroll"}
        }, {
          header: _withCtx(() => []),
          body: _withCtx(() => [
            _createElementVNode("table", null, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.Lang.getI18N("employee")), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date) => {
                    return (_openBlock(), _createElementBlock("th", _hoisted_15, _toDisplayString(_ctx.DateUtils.formatDate(date)), 1))
                  }), 256)),
                  _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.Lang.getI18N("total")), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getEmployees(), (employee) => {
                  return (_openBlock(), _createElementBlock("tr", null, [
                    _createElementVNode("th", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("span", null, _toDisplayString(employee.name) + " " + _toDisplayString(employee.surname), 1),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.homeState.getRoleName(employee.role)), 1)
                      ])
                    ]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date) => {
                      return (_openBlock(), _createElementBlock("td", null, [
                        _createElementVNode("div", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getGroupedEntries(employee, date), (group) => {
                            return (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (entry) => {
                                return (_openBlock(), _createBlock(_component_Badge, {
                                  class: _normalizeClass(_ctx.getBadgeClass(entry, group)),
                                  color: entry.getColor(),
                                  style: _normalizeStyle(
                          entry.incoherence ? 'border: red 2px solid' : ''
                        ),
                                  onClick: ($event: any) => (_ctx.openEditModal(entry, employee, date))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(entry.getLabel()), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class", "color", "style", "onClick"]))
                              }), 256))
                            ]))
                          }), 256)),
                          _createVNode(_component_Badge, {
                            onClick: ($event: any) => (_ctx.addPunchCard(employee, date)),
                            color: "#c2c4f2"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ]))
                    }), 256)),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.DateUtils.convertHoursToHHMM(
                        _ctx.computeTotalWorkingHours(employee)
                      )), 1)
                    ])
                  ]))
                }), 256))
              ]),
              _createElementVNode("tfoot", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", _hoisted_24, _toDisplayString(_ctx.Lang.getI18N("total-hours")), 1),
                  _createElementVNode("td", {
                    colspan: _ctx.dates.length + 1
                  }, _toDisplayString(_ctx.DateUtils.convertHoursToHHMM(_ctx.getTotalHours())), 9, _hoisted_25)
                ])
              ])
            ])
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}